import { SITE } from '@/app/constants';
import type { ToolTaskType } from '@/app/types';

export const ZH_GUIDE_URL = 'https://shengshu.feishu.cn/docx/Dtv8dbnUKo5glfxDoLXcEwzSnyd';
export const EN_GUIDE_URL = 'https://shengshu.feishu.cn/docx/MtKHd8OhNokOtaxzxQHcdUDPnKh';

const BASE_URL =
  SITE === 'global' ? 'https://image01.cf.vidu.studio/vidu/media-asset' : 'https://image01.vidu.zone/vidu/media-asset';

type ExampleMediaPreviewBadgeKey = 'tools.example' | 'tools.before' | 'tools.after';
type ExampleMediaPreviewTitleKey =
  | 'create.extendForm.title'
  | 'task.action.imageEdit'
  | 'task.action.videoEdit'
  | 'tools.characterCreation.title'
  | 'tools.faceSwap.title'
  | 'tools.lipSync.title'
  | 'tools.oneClickMv.title'
  | 'tools.oneClickVideoProduction.title'
  | 'tools.textToSpeech.title'
  | 'tools.upscale.image.title'
  | 'tools.upscale.video.title'
  | 'tools.videoRemake.title';

export type ExampleMediaToolType = ToolTaskType | 'video2extend' | 'video_edit' | 'image_edit';

interface ExampleMediaPreviewConfig {
  imageUrl?: string;
  videoUrl?: string;
  titleKey: ExampleMediaPreviewTitleKey;
  badgeKeys?: readonly ExampleMediaPreviewBadgeKey[];
  poster?: string;
}

export const STYLE_OPTIONS = [
  { id: 'anime', labelKey: 'tools.styleOptions.anime' },
  { id: 'realistic', labelKey: 'tools.styleOptions.realistic' },
  { id: 'oil_painting', labelKey: 'tools.styleOptions.oilPainting' },
  { id: 'watercolor', labelKey: 'tools.styleOptions.watercolor' },
  { id: 'sketch', labelKey: 'tools.styleOptions.sketch' },
] as const;

export const CHARACTER_TAG_OPTIONS = [
  { id: 'role', labelKey: 'tools.characterCreation.tags.character' },
  { id: 'prop', labelKey: 'tools.characterCreation.tags.prop' },
  { id: 'scene', labelKey: 'tools.characterCreation.tags.scene' },
] as const;

export const EXAMPLE_MEDIA_PREVIEW_CONFIG: Partial<Record<ExampleMediaToolType, ExampleMediaPreviewConfig>> = {
  face_swap: {
    videoUrl: `${BASE_URL}/face_swap-8e7dd778.mp4`,
    titleKey: 'tools.faceSwap.title',
    badgeKeys: ['tools.example'],
  },
  image_edit: {
    imageUrl: `${BASE_URL}/edit-image-71df4940.webp`,
    titleKey: 'task.action.imageEdit',
    badgeKeys: ['tools.before', 'tools.after'],
  },
  one_click: {
    videoUrl: `${BASE_URL}/one_click-11f57240.mp4`,
    titleKey: 'tools.oneClickVideoProduction.title',
    badgeKeys: ['tools.example'],
  },
  music_video: {
    // Placeholder preview until dedicated MV demo assets are ready.
    videoUrl: `${BASE_URL}/one_click-11f57240.mp4`,
    titleKey: 'tools.oneClickMv.title',
    badgeKeys: ['tools.example'],
  },
  lip_sync: {
    videoUrl: `${BASE_URL}/one_click-11f57240.mp4`,
    titleKey: 'tools.lipSync.title',
    badgeKeys: ['tools.example'],
  },
  remake: {
    videoUrl: `${BASE_URL}/remake-3be701b4.mp4`,
    titleKey: 'tools.videoRemake.title',
    badgeKeys: ['tools.before', 'tools.after'],
  },
  upscale: {
    videoUrl: `${BASE_URL}/upscale-36798343.mp4`,
    titleKey: 'tools.upscale.video.title',
    badgeKeys: ['tools.before', 'tools.after'],
  },
  upscale_image: {
    imageUrl: `${BASE_URL}/upscale-image-c37faa2e.webp`,
    titleKey: 'tools.upscale.image.title',
    badgeKeys: ['tools.before', 'tools.after'],
  },
  video2extend: {
    videoUrl: `${BASE_URL}/extend-cb101c7b.mp4`,
    titleKey: 'create.extendForm.title',
  },
  video_edit: {
    videoUrl: `${BASE_URL}/edit_video-e467e801.mp4`,
    titleKey: 'task.action.videoEdit',
    badgeKeys: ['tools.before', 'tools.after'],
  },
};
